// Shared look for the leaderboard tables, cards, and breakdown dialog: hairline
// rows instead of a cell grid, rounded containers with a faint outline, muted
// headers, and pale tints in place of saturated fills.
export const soft = {
  text: '#1F2933',
  muted: '#6B7280',
  faint: '#9AA3AD',
  hairline: '#F1F3F5',
  outline: '#EDF0F3',
  headBg: '#F8F9FB',
  hoverBg: '#F7F9FC',
  meBg: '#EEF5FC',
  meHoverBg: '#E3EEFA',
  accent: '#0062B8',
  okBg: '#E7F4EA',
  ok: '#2E7D32',
  missBg: '#F6F7F9',
  miss: '#B4232A',
  radius: '12px',
};

// Rounded container that replaces the old boxed table border.
export const softContainerSx = {
  backgroundColor: '#FFFFFF',
  borderRadius: soft.radius,
  boxShadow: `0 1px 2px rgba(16, 24, 40, 0.06), 0 0 0 1px ${soft.outline}`,
  overflow: 'hidden',
};

// Header and body cells: no column lines, one hairline between rows.
export const softHeadCellSx = {
  backgroundColor: soft.headBg,
  color: soft.muted,
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  padding: '10px 14px',
  whiteSpace: 'nowrap',
};

export const softBodyCellSx = {
  color: soft.text,
  fontSize: '14px',
  borderBottom: 'none',
  borderTop: `1px solid ${soft.hairline}`,
  padding: '12px 14px',
  fontVariantNumeric: 'tabular-nums',
};

// The signed-in player's row: pale blue with a thin accent bar on the left.
export const meRowFirstCellShadow = `inset 3px 0 0 ${soft.accent}`;

export const fadeWhileLoading = (isLoading) => ({
  opacity: isLoading ? 0.5 : 1,
  transition: 'opacity 150ms ease',
});
